<div class="app-background border-gray-400 ml-4">
  <p-breadcrumb
    [model]="items"
    [home]="home"
    [style]="{
      '--p-breadcrumb-padding': '1rem 0.5rem 0.5rem 0.50rem',
      '--p-breadcrumb-separator-color': 'var(--p-primary-color)',
    }"
  />
</div>
